import type {ReactNode} from 'react'
import {cx} from '@local/utils/cx'

export interface PastilProps {
	children: ReactNode
	className?: string
	variant?: 'filled' | 'filled-dark' | 'outlined' | 'grey'
	onClick?: (e) => void
}

export const Pastil = ({children, className, variant = 'filled', onClick}: PastilProps) => {
	return (
		<div
			onClick={onClick}
			className={cx(
				'w-fit h-fit text-9 px-4 py-3 uppercase font-medium rounded tracking-widest leading-none',
				variant === 'filled' && 'bg-white text-grey-5',
				variant === 'filled-dark' && 'bg-grey-5 text-white',
				variant === 'outlined' && 'bg-transparent border border-white text-white',
				variant === 'grey' && 'bg-grey-1 text-grey-5',
				className,
			)}>
			{children}
		</div>
	)
}
